import { default as React, useContext } from 'react'
import SearchControl from "../SearchControl"
import { Stack } from '@mui/material'
import { LoadingButton } from '@mui/lab';
import AddIcon from '@mui/icons-material/Add'

export default function ArticlesCommandBar(props={ showAdd: true, addRecordButtonVariant: '', addRecord: undefined, addRecordLabel: 'Add' }) {
  return <Stack direction='row' gap={1}>
    {(props.showAdd === undefined || props.showAdd) && <LoadingButton loading={props.loading} variant={props.addRecordButtonVariant ?? "outlined"} onClick={props.addRecord} title={props.addRecordLabel ?? 'Add'}><AddIcon /></LoadingButton>}
    <SearchControl />
  </Stack>
}